import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ConnectionService } from '../services/connection.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const conn = inject(ConnectionService);
  // Any plain HTTP (not HTTPS) request targets a local device — never add the cloud Bearer token.
  // The cloud API always uses HTTPS, so this is always safe.
  const isLanRequest = req.url.startsWith('http://') && !req.url.startsWith('http://localhost');

  const token = auth.getAccessToken();
  const authReq = token && !isLanRequest
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401 && !req.url.includes('/auth/') && !isLanRequest && !auth.isGuest()) {
        return auth.refresh().pipe(
          switchMap(() => {
            const newToken = auth.getAccessToken();
            const retryReq = newToken
              ? req.clone({ setHeaders: { Authorization: `Bearer ${newToken}` } })
              : req;
            return next(retryReq);
          }),
          catchError(() => {
            auth.logout();
            router.navigate(['/dashboard']);
            return throwError(() => err);
          }),
        );
      }
      return throwError(() => err);
    }),
  );
};
